import { RestHoursScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeSource } from '../personnel-source.js';

/**
 * Çalışma ve dinlenme saatleri (ortak ekran `RestHoursScreen`; ADR 0016–0018). Ofiste yalnız
 * okunur: saatler gemide girilir [MLC A2.3 §12]. "Active Alerts" kartı yok; sertifika uyarıları
 * Certificates'ta (ADR 0068 §7).
 */
export function RestHoursPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('restHours.title')}>
      <RestHoursScreen source={officeSource} />
    </Shell>
  );
}
